export const SET_REDIRECT = 'SET_REDIRECT'
export const REQUEST_COLLECTION_CHANGE_STEP = 'REQUEST_COLLECTION_CHANGE_STEP'
export const RECORD_BIN_FULLNESS_CHANGE_STEP = 'RECORD_BIN_FULLNESS_CHANGE_STEP'
